import { render, staticRenderFns } from "./TenderMemberRow.vue?vue&type=template&id=0848bc19&scoped=true&"
import script from "./TenderMemberRow.vue?vue&type=script&lang=js&"
export * from "./TenderMemberRow.vue?vue&type=script&lang=js&"
import style0 from "./TenderMemberRow.vue?vue&type=style&index=0&id=0848bc19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848bc19",
  null
  
)

export default component.exports